function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useLogout, LogoutKind, useSetCredentials } from '@dentalux/security';
import { Avatar } from '@dentalux/ui-library-core/components/avatar';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import BaseListItemIcon from '@mui/material/ListItemIcon';
import BaseMenuItem from '@mui/material/MenuItem';
import { LocalStorage } from 'src/@types/LocalStorage';
import SettingsIcon from 'src/components/icons/Settings';
import SignOutIcon from 'src/components/icons/SignOut';
import usePerson from 'src/graphql/hooks/usePerson';
import { useProfileImage } from 'src/hooks/api/useProfileImage';
import { useInitials } from 'src/hooks/useInitials';
import { Photo } from '../icons/Photo';
import Menu from '../Menu';
import { reset as authroizedReset, useAuthorizedDispatch } from '../providers/AuthorizedProvider';
import { setDefaultBookingContext, useBookingsDispatch } from '../providers/BookingsProvider';
import { usePersonId } from '../providers/PersonIdProvider';
import { setDisableBiometricLogin, useUnauthorizedDispatch } from '../providers/UnauthorizedProvider';
import * as S from './SettingsMenu.styles';
const SettingsMenu = () => {
  const {
    t
  } = useTranslation();
  const logout = useLogout({
    kind: LogoutKind.MANUAL
  });
  const authorizedDispatch = useAuthorizedDispatch();
  const unauthorizedDispatch = useUnauthorizedDispatch();
  const bookingsDispatch = useBookingsDispatch();
  const setCredentials = useSetCredentials();
  const router = useRouter();
  const personReferenceId = usePersonId();
  const {
    data: person
  } = usePerson({
    variables: {
      personReferenceId
    },
    skip: !personReferenceId
  });
  const accountSettingsRoute = '/account-settings';
  const handleLogOut = () => {
    localStorage.removeItem(LocalStorage.RedirectUrl);
    logout().then(() => {
      setCredentials(null, 'local');
      unauthorizedDispatch(setDisableBiometricLogin());
      authorizedDispatch(authroizedReset());
      bookingsDispatch(setDefaultBookingContext());
    });
  };
  const handleDeleteAccount = () => router.push(accountSettingsRoute);
  const {
    src: profileImageSrc
  } = useProfileImage({});
  const initials = useInitials({
    person
  });
  const avatarProps = profileImageSrc ? {
    src: profileImageSrc
  } : {
    children: initials
  };
  return /*#__PURE__*/React.createElement(Menu, {
    justifyContent: "right",
    trigger: /*#__PURE__*/React.createElement(S.Trigger, null, /*#__PURE__*/React.createElement(Avatar, _extends({
      size: "m"
    }, avatarProps)))
  }, /*#__PURE__*/React.createElement(S.About, null, /*#__PURE__*/React.createElement(S.Link, {
    href: accountSettingsRoute,
    passHref: true
  }, /*#__PURE__*/React.createElement(S.Frame, null, /*#__PURE__*/React.createElement(Avatar, _extends({
    size: "l"
  }, avatarProps)), /*#__PURE__*/React.createElement(S.PhotoIcon, null, /*#__PURE__*/React.createElement(Photo, {
    width: 11,
    height: 8
  })))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(S.Name, null, `${person?.firstName} ${person?.lastName}`))), /*#__PURE__*/React.createElement(S.BaseMenuList, null, /*#__PURE__*/React.createElement(BaseMenuItem, {
    onClick: handleDeleteAccount
  }, /*#__PURE__*/React.createElement(BaseListItemIcon, null, /*#__PURE__*/React.createElement(SettingsIcon, null)), /*#__PURE__*/React.createElement(S.ListItemText, {
    primary: t('common.settings_menu.settings')
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(BaseMenuItem, {
    onClick: handleLogOut
  }, /*#__PURE__*/React.createElement(BaseListItemIcon, null, /*#__PURE__*/React.createElement(SignOutIcon, null)), /*#__PURE__*/React.createElement(S.ListItemText, {
    primary: t('common.settings_menu.logout')
  }))));
};
export default SettingsMenu;